
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.123 17.128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M16.893 15.375l-4.48-4.444a6.736 6.736 0 001.207-2.785 5.977 5.977 0 00.12-1.255A6.922 6.922 0 006.87 0 6.827 6.827 0 004.25.52a7.224 7.224 0 00-2.303 1.447 7.077 7.077 0 00-.856 1.1 7.959 7.959 0 00-.968 2.42 6.966 6.966 0 00.425 4.046 6.711 6.711 0 001.417 2.18 6.892 6.892 0 008.4 1.04 8.63 8.63 0 00.518-.352l4.495 4.495a.777.777 0 00.553.23c.383.038.718-.403.964-.64a.787.787 0 00-.002-1.11zM7.011 2.2a4.677 4.677 0 11-1.961 8.98 4.631 4.631 0 01-1.435-7.595 3.363 3.363 0 01.69-.591 3.608 3.608 0 01.79-.416 4.869 4.869 0 011.788-.377.82.82 0 00.128-.001z"}})])
          )
        }
      }
    